module.exports = __webpack_public_path__ + "dc3aaa77988a7c23bb0ad130173e9f75.svg";